export default __webpack_public_path__ + "images/cert-e90.png?5c2d6654a2a13293d3ad0b07cca03b17";